<div class="org-div">
  <ion-img [src]="orgLogo" class="org-logo" [matMenuTriggerFor]="menu">
  </ion-img>
  <mat-menu #menu="matMenu">
    <button mat-menu-item button class="menu-item" *ngFor="let item of menuItems" (click)="navigateTo(item.route)" [disabled]="!item.enabled"
    [matTooltip]="!item.enabled ? 'Coming soon...' : null"
    matTooltipPosition="right">
      <div class="settings">
        <ion-img [src]="item.icon" class="settings-img"></ion-img>
        <span>{{ item.label }}</span>
      </div>
    </button>
  </mat-menu>
</div>


